import type { PrivilegeType } from '@/types';
import { useLingui } from '@lingui/react';
import { Grid } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import { VipClubDetailItem } from './VipClubDetailItem';
export const VipClubDetail: React.FC<PrivilegeType> = ({
  ...props
}) => {
  const {
    i18n
  } = useLingui();
  const isTablet = useMediaQuery('(max-width: 62em)');
  const isMobile = useMediaQuery('(max-width: 36em)');
  return <Grid w="100%" gutter={0} grow>
      <VipClubDetailItem title={i18n._('Level')} description={props.level} justify="start" visibleForm="lg" isLeftRadius />
      <VipClubDetailItem title={i18n._('Rakeback')} description={props.rakeback} justify="center" isLeftRadius={isTablet} />
      <VipClubDetailItem title={i18n._('Rank-Up Bonus')} status={props.rankUpBonus} justify="center" w={{
      base: 50,
      lg: 60
    }} />
      <VipClubDetailItem title={i18n._('Daily Bonus')} status={props.dailyBonus} justify="center" w={{
      base: 40,
      lg: 50
    }} />

      <VipClubDetailItem title={i18n._('Weekly Bonus')} status={props.weeklyBonus} justify="center" w={{
      base: 50,
      lg: 60
    }} />
      <VipClubDetailItem title={i18n._('Monthly Bonus')} status={props.monthlyBonus} justify="center" w={{
      base: 50,
      lg: 70
    }} isRightRadius={isMobile} />
      <VipClubDetailItem title={i18n._('Reload Bonus')} status={props.reloadBonus} justify="center" w={{
      base: 40,
      lg: 50
    }} isLeftRadius={isMobile} />
      <VipClubDetailItem title={i18n._('VIP Host')} status={props.vipHost} justify="center" w={{
      base: 30,
      lg: 50
    }} />
      <VipClubDetailItem title={i18n._('Sponsored Battles')} status={props.sponsoredBattles} justify="center" w={80} />
      <VipClubDetailItem title={i18n._('Customized Benefits')} status={props.customizedBenefits} justify="center" isRightRadius w={90} />
    </Grid>;
};